var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEntrar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;fill-opacity:0;opacity:0;}.cls-2{fill:#cd992b;}.cls-3{fill:#ffd400;}.cls-4{fill:#ffc20e;}.cls-4,.cls-5{fill-rule:evenodd;}.cls-5{fill:#00416b;}.cls-6{fill:#0083ca;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "entrar-cor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\xCDcones_Personalizados",
    "data-name": "\\xCDcones Personalizados"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 96,
    height: 96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84,15.6V80.4A3.64,3.64,0,0,1,80.31,84H39.69A3.64,3.64,0,0,1,36,80.4V15.6A3.64,3.64,0,0,1,39.69,12H80.31a3.69,3.69,0,0,1,2.62,1.07A3.5,3.5,0,0,1,84,15.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M80,15.6V80.4A3.64,3.64,0,0,1,76.31,84H35.69A3.64,3.64,0,0,1,32,80.4V15.6A3.64,3.64,0,0,1,35.69,12H76.31a3.69,3.69,0,0,1,2.62,1.07A3.5,3.5,0,0,1,80,15.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M80,15.6V80.4A3.64,3.64,0,0,1,76.31,84H35.69A3.64,3.64,0,0,1,32,80.4V60L78.93,13.07A3.5,3.5,0,0,1,80,15.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M58.29,45.65,44,26V40H16a4,4,0,0,0-4,4v8a4,4,0,0,0,4,4H44V70L58.29,50.35A4,4,0,0,0,58.29,45.65Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 72,
    cy: 48,
    r: 4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntrar);
export default __webpack_public_path__ + "static/media/entrar.6d23c15c1020b068d9da881a735d0ac9.svg";
export { ForwardRef as ReactComponent };